/**
 * Dependencies.
 */
import { BaseModel, email, endpoint, prop, required } from '@prz-dp/services';

/**
 * Export `UserModel`.
 */
@endpoint('servicePointUser')
export class UserModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  id?: number;

  @required()
  @email()
  email: string;

  @required()
  isActive: boolean;

  @required()
  name: string;

  @required()
  prozisUserId: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<UserModel>) {
    super(data);
  }
}
